import { computed } from 'mobx';
import { PartialDeep } from 'type-fest';

import {
  AbstractTheme,
  CampaignFlagsMap,
  ControlledFeaturesMap,
  Theme,
} from 'themes/themes.types';
import { getThemePart } from 'themes/utils';

import {
  getBuyTokensModalConfig,
  getChatOfferConfig,
  getDrawerMenuConfig,
  getGamesThemeConfig,
  getHeaderCTAConfig,
  getInfoStripConfig,
  getLogoThemeConfig,
  getMobileOverlayConfig,
  getOnCamAnimationConfig,
  getRegistrationOverlayConfig,
  getTippingSoundsConfig,
} from './utils';


export default class SummerTheme extends AbstractTheme {
  static CFS: ControlledFeaturesMap = {};

  static CAMPAIGN_FLAGS: CampaignFlagsMap = {
    BUY_TOKENS_MODAL: 'SUMMER_BUY_TOKENS_MODAL',
    CHAT_OFFER: 'SUMMER_CHAT_OFFER',
    DRAWER_MENU: 'SUMMER_DRAWER_MENU_STRIP',
    GAMES: 'SUMMER_GAMES',
    HEADER_CTA: 'SUMMER_HEADER_CTA',
    INFO_STRIP: 'SUMMER_INFO_STRIP',
    LOGO: 'SUMMER_LOGO',
    MOBILE_OVERLAY: 'SUMMER_MOBILE_OVERLAY',
    ON_CAM_ANIMATION: 'SUMMER_ON_CAM_ANIMATION',
    REGISTRATION_OVERLAY: 'SUMMER_REGISTRATION_OVERLAY',
    TIPPING: 'SUMMER_TIPPING',
  };

  @computed get theme(): PartialDeep<Theme> {
    return {

      buyTokensModal: getThemePart<'buyTokensModal'>(
        SummerTheme.CAMPAIGN_FLAGS.BUY_TOKENS_MODAL,
        getBuyTokensModalConfig
      ),

      chatOffer: getThemePart<'chatOffer'>(
        SummerTheme.CAMPAIGN_FLAGS.CHAT_OFFER,
        getChatOfferConfig
      ),

      drawerMenu: getThemePart<'drawerMenu'>(
        SummerTheme.CAMPAIGN_FLAGS.DRAWER_MENU,
        getDrawerMenuConfig
      ),

      games: getThemePart<'games', true>(
        SummerTheme.CAMPAIGN_FLAGS.GAMES,
        getGamesThemeConfig
      ),

      headerCTA: getThemePart<'headerCTA'>(
        SummerTheme.CAMPAIGN_FLAGS.HEADER_CTA,
        getHeaderCTAConfig
      ),

      infoStrip: getThemePart<'infoStrip'>(
        SummerTheme.CAMPAIGN_FLAGS.INFO_STRIP,
        getInfoStripConfig
      ),

      logoImage: getThemePart<'logoImage'>(
        SummerTheme.CAMPAIGN_FLAGS.LOGO,
        getLogoThemeConfig
      ),

      mobileOverlay: getThemePart<'mobileOverlay'>(
        SummerTheme.CAMPAIGN_FLAGS.MOBILE_OVERLAY,
        getMobileOverlayConfig
      ),

      onCamAnimation: getThemePart<'onCamAnimation'>(
        SummerTheme.CAMPAIGN_FLAGS.ON_CAM_ANIMATION,
        getOnCamAnimationConfig
      ),

      registrationOverlay: getThemePart<'registrationOverlay'>(
        SummerTheme.CAMPAIGN_FLAGS.REGISTRATION_OVERLAY,
        getRegistrationOverlayConfig
      ),

      tipping: getThemePart<'tipping', true>(
        SummerTheme.CAMPAIGN_FLAGS.TIPPING,
        getTippingSoundsConfig
      ),

    };
  }
}
